import React from 'react'
import StockBalanceReport from '../Components/Reports/StockBalanceReport'

function StockBalanceReportPage() {
  return (
    <>
    <StockBalanceReport/>
    </>
  )
}

export default StockBalanceReportPage
